export const SINGLE_SCAN_REQUEST = 'SINGLE_SCAN_REQUEST';
export const SINGLE_SCAN_SUCCESS = 'SINGLE_SCAN_SUCCESS';
export const SINGLE_SCAN_FAILURE = 'SINGLE_SCAN_FAILURE';